import { useEffect, useState } from "react";
import { Maximize2, X } from "lucide-react";
import { MembershipCard } from "@/components/MembershipCard";
import { api } from "@/lib/api";

export default function KadAhli() {
  const [member, setMember] = useState(null);
  const [profile, setProfile] = useState(null);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fullscreen, setFullscreen] = useState(false);

  useEffect(() => {
    Promise.all([api.get("/members/me"), api.get("/members/me/profile")])
      .then(async ([m, p]) => {
        setMember(m.data);
        setProfile(p.data);
        if (m.data.membership_category_id) {
          const cats = await api.get("/categories");
          setCategory(cats.data.find((c) => c.id === m.data.membership_category_id));
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!fullscreen) return;
    const onKey = (e) => { if (e.key === "Escape") setFullscreen(false); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [fullscreen]);

  if (loading) return <div className="p-8 text-center text-piks-muted">Memuatkan kad ahli...</div>;
  if (!member) return <div className="p-8 text-center text-piks-muted" data-testid="kad-ahli-empty-state">Kad ahli tidak tersedia.</div>;

  return (
    <div className="p-6 sm:p-10 flex flex-col items-center" data-testid="kad-ahli-page">
      <h1 className="font-display text-xl font-bold text-piks-black mb-6 self-start">Kad Ahli Digital</h1>
      <button
        onClick={() => setFullscreen(true)}
        data-testid="kad-open-fullscreen-btn"
        className="block w-full max-w-md cursor-zoom-in group"
        aria-label="Papar kad ahli skrin penuh"
      >
        <div className="relative">
          <MembershipCard member={member} profile={profile} category={category} />
          <div className="absolute inset-0 rounded-2xl bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
            <Maximize2 className="w-7 h-7 text-white drop-shadow-lg" />
          </div>
        </div>
      </button>
      <button onClick={() => setFullscreen(true)} data-testid="kad-fullscreen-btn" className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-piks-black hover:text-piks-red">
        <Maximize2 className="w-4 h-4" /> Papar Skrin Penuh
      </button>
      <p className="text-xs text-piks-muted mt-6 text-center max-w-sm">Imbas kod QR pada kad ini untuk pengesahan awam status keahlian anda tanpa mendedahkan maklumat peribadi sensitif.</p>

      {(member.effective_status === "EXPIRED" || member.effective_status === "EXPIRING_SOON") && (
        <div
          data-testid="kad-expiry-cta"
          className={`mt-4 max-w-md w-full rounded-xl border p-4 text-sm text-center ${member.effective_status === "EXPIRED" ? "bg-red-50 border-red-200 text-piks-red" : "bg-amber-50 border-amber-200 text-amber-800"}`}
        >
          {member.effective_status === "EXPIRED"
            ? "Keahlian anda telah tamat tempoh. Sila hubungi urusetia PPPS untuk memperbaharui keahlian anda."
            : `Keahlian anda akan tamat tempoh pada ${new Date(member.valid_until).toLocaleDateString("ms-MY")}. Sila hubungi urusetia PPPS untuk pembaharuan lebih awal.`}
        </div>
      )}

      {fullscreen && (
        <div
          className="fixed inset-0 z-[100] bg-black flex items-center justify-center"
          data-testid="kad-fullscreen-overlay"
          onClick={() => setFullscreen(false)}
        >
          <button
            onClick={() => setFullscreen(false)}
            data-testid="kad-fullscreen-close-btn"
            className="absolute top-5 right-5 z-10 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
            aria-label="Tutup"
          >
            <X className="w-5 h-5" />
          </button>
          <div className="kad-landscape-force" onClick={(e) => e.stopPropagation()}>
            <MembershipCard member={member} profile={profile} category={category} />
          </div>
        </div>
      )}
    </div>
  );
}
